/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from "react";
// all icons and other images
import { CustomAutoComplete } from "./CustomAutoComplete";
import FlightDatePicker from "./FlightDatePicker";
import { Popover } from "antd";
import moment from "../../../node_modules/moment/moment";
import { ONE_WAY_TRIP, ROUND_TRIP } from "constants/common";

// import { useNavigate } from "react-router-dom";

import { CloseCircleFilled } from "@ant-design/icons";

export default function MultiCityFlightSearch({
  mainType,
  departureDate,
  getFinalMultiCityArray,
  sourceStation,
  destination,
}) {
  // states
  const initialState = {
    showFromDropDown: false,
    showToDropDown: false,
    sourceStation: sourceStation,
    destination: destination,
    departure_date: moment(departureDate).add("day", 1),
    arrival_date: null,
    adultCount: 0,
    childCount: 0,
    infantCount: 0,
    travelClass: null,
    tripType: ONE_WAY_TRIP,
    airports: [],
    errors: null,
  };
  const inputElement = [
    {
      ...initialState,
    },
  ];
  const [state, setState] = useState(initialState);
  const [multiCityControls, setMultiCityControls] = useState(inputElement);
  // eslint-disable-next-line no-unused-vars
  const [tripType, setTripType] = useState(ONE_WAY_TRIP);
  // const navigate = useNavigate();

  useEffect(() => {
    const _tempInputValues = [...multiCityControls];
    multiCityControls[0]["sourceStation"] = destination;
    multiCityControls[0]["destination"] = null;

    setMultiCityControls(_tempInputValues);
  }, [destination]);

  const handleShowHideAutocomplete = (type, index) => {
    if (type === "from") {
      const _tempInputValues = [...multiCityControls];
      multiCityControls[index]["showFromDropDown"] = true;
      multiCityControls[index]["showToDropDown"] = false;
      setMultiCityControls(_tempInputValues);
    } else {
      const _tempInputValues = [...multiCityControls];
      multiCityControls[index]["showFromDropDown"] = false;
      multiCityControls[index]["showToDropDown"] = true;
      setMultiCityControls(_tempInputValues);
    }
  };

  const getFromToValue = (value, type, index) => {
    console.log("index", index);
    if (type === "from") {
      const _tempInputValues = [...multiCityControls];
      multiCityControls[index]["sourceStation"] = value;
      multiCityControls[index]["showFromDropDown"] = false;

      setMultiCityControls(_tempInputValues);
    } else {
      const _tempInputValues = [...multiCityControls];
      multiCityControls[index]["destination"] = value;
      multiCityControls[index]["showToDropDown"] = false;
      if (multiCityControls.length > 0) {
        if (multiCityControls[index]["destination"]) {
          if (multiCityControls[index + 1]) {
            multiCityControls[index + 1]["sourceStation"] =
              multiCityControls[index]["destination"];
          }
        }
      }
      setMultiCityControls(_tempInputValues);
    }
  };

  // date changes
  const handleDateChange = (dt, name, index) => {
    console.log("date", dt);
    const _tempInputValues = [...multiCityControls];
    multiCityControls[index][name] = dt;
    setMultiCityControls(_tempInputValues);
  };

  useEffect(() => {
    if (tripType === ROUND_TRIP) {
      setState({ ...state, arrival_date: moment().add("day", 1) });
    }
  }, [tripType]);

  useEffect(() => {
    console.log("multiCityControls", multiCityControls);
    let finalMultiCityArray = [];
    multiCityControls.map((d) => {
      let source = d.sourceStation ? d.sourceStation.split("/") : [null];
      let destination = d.destination ? d.destination.split("/") : [null];

      //   if (d.sourceStation.split[0]) {
      console.log("sourceStation", d.sourceStation);
      finalMultiCityArray = [
        ...finalMultiCityArray,
        {
          from: source[0],
          to: destination[0],
          code_from: source[1],
          code_to: destination[1],
          depatureDate: moment(d.departure_date).format("YYYY/MM/DD"),
        },
      ];
      //   }

      return null;
    });
    console.log("Final Multi City Array", finalMultiCityArray);
    getFinalMultiCityArray(finalMultiCityArray);
  }, [multiCityControls]);

  const onAddMoreCity = (index) => {
    let nextDate = moment(multiCityControls[index]["departure_date"]).format(
      "YYYY/MM/DD"
    );
    let nextSourceStation = multiCityControls[index]["destination"];
    console.log(multiCityControls);

    setMultiCityControls([
      ...multiCityControls,
      {
        departure_date: moment(nextDate).add("day", 1),
        showFromDropDown: false,
        showToDropDown: false,
        sourceStation: nextSourceStation ? nextSourceStation : "Select City",
        destination: null,
        arrival_date: null,
        adultCount: 0,
        childCount: 0,
        infantCount: 0,
        travelClass: null,
        tripType: ONE_WAY_TRIP,
        airports: [],
        errors: null,
      },
    ]);
  };

  const onRemoveCity = () => {
    setMultiCityControls(
      multiCityControls.slice(0, multiCityControls.length - 1)
    );
  };

  console.log("multiCityControls", multiCityControls);
  if (sourceStation && destination) {
    return (
      <>
        {multiCityControls.map((item, index) => {
          console.log("item", item);
          return (
            <>
              <div className="custom-radiolist">
                <div className="search-content-box">
                  <div className="search-area-filter">
                    <div class="main-search-left-section">
                      <div
                        className={`search-left first-left-section cursor-pointer ${
                          item.showFromDropDown && "active"
                        }`}
                      >
                        <div className="search-left-content">
                          <span
                            onClick={() =>
                              handleShowHideAutocomplete("from", index)
                            }
                            className="text-uppercase color-secondary font-size-14 clickable-span"
                          >
                            Depart From
                          </span>
                          {
                            <h2
                              onClick={() =>
                                handleShowHideAutocomplete("from", index)
                              }
                              className="mb-0"
                            >
                              <strong>
                                {item.sourceStation
                                  ? item.sourceStation.split("/")[0]
                                  : "Select City"}
                              </strong>
                            </h2>
                          }
                          {item.sourceStation && (
                            <span className="location-text font-size-14">
                              {item.sourceStation !== "Select City"
                                ? `${item.sourceStation.split("/")[1]}`
                                : ""}{" "}
                            </span>
                          )}

                          {item.showFromDropDown && (
                            <CustomAutoComplete
                              getFromToValue={getFromToValue}
                              type="from"
                              index={index}
                              tripType={tripType}
                              airports={state.airports}
                              popupClassName={`autocomplete-dropdown-${index}`}
                            />
                          )}
                        </div>
                      </div>
                      <div
                        className={`search-left second-left-section cursor-pointer ${
                          item.showToDropDown && "active"
                        }`}
                      >
                        <div className="search-left-content">
                          <span
                            onClick={() =>
                              handleShowHideAutocomplete("to", index)
                            }
                            className="text-uppercase color-secondary font-size-14  clickable-span"
                          >
                            Arrive At
                          </span>
                          <h2
                            onClick={() =>
                              handleShowHideAutocomplete("to", index)
                            }
                            className="mb-0"
                          >
                            <strong>
                              {item.destination
                                ? item.destination.split("/")[0]
                                : "Select City"}
                            </strong>
                          </h2>
                          <span className="location-text font-size-14">
                            {item.destination
                              ? `${item.destination.split("/")[1]}`
                              : ""}{" "}
                          </span>
                          {item.showToDropDown && (
                            <CustomAutoComplete
                              getFromToValue={getFromToValue}
                              type="to"
                              index={index}
                              tripType={tripType}
                              popupClassName={`autocomplete-dropdown-${index}`}
                            />
                          )}
                        </div>
                        {console.log("Source", item.sourceStation)}
                        {console.log("destination", item.destination)}

                        {/* {item.sourceStation !== null &&
                          item.destination !== null &&
                          item.sourceStation === item.destination && (
                            <div
                              class="errorSection makeFlex"
                              id="errorMessage"
                            >
                              <span class="landingSprite errorIcon appendRight10"></span>
                              <span
                                data-cy="sameCityError"
                                class="redText errorMsgText"
                              >
                                Source &amp; Destination airports cannot be the
                                same, please select diffrent airport
                              </span>
                            </div>
                          )} */}
                      </div>
                    </div>
                    <div class="main-search-right-section">
                      <div className={`search-left p-0`}>
                        <div
                          className={`search-left-content deprature-return-section`}
                        >
                          <Popover
                            placement="bottom"
                            content={() => (
                              <FlightDatePicker
                                handleDateChange={(dt) =>
                                  handleDateChange(dt, "departure_date", index)
                                }
                                tripType={tripType}
                                minDate={
                                  multiCityControls[index - 1]
                                    ? new Date(
                                        moment(
                                          multiCityControls[index - 1][
                                            "departure_date"
                                          ]
                                        ).add("day", 1)
                                      )
                                    : item.departure_date
                                }
                              />
                            )}
                          >
                            <div
                              className={`deprature-section deprature-return-content border-none`}
                            >
                              <div className="deprature-title d-flex">
                                Deprature
                                <span className="ml-3">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="11"
                                    height="6"
                                    viewBox="0 0 11 6"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M1.12508 0.528512C1.38562 0.268165 1.80802 0.268165 2.06855 0.528512L5.59959 4.05712L9.13064 0.528512C9.39116 0.268165 9.81358 0.268165 10.0741 0.528512C10.3346 0.788865 10.3346 1.21097 10.0741 1.47133L6.07132 5.47132C5.81081 5.73165 5.38838 5.73165 5.12787 5.47132L1.12508 1.47133C0.864556 1.21097 0.864556 0.788865 1.12508 0.528512Z"
                                      fill="#118DFF"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <h3 className="deprature-date font-weight-bold d-flex align-items-end mb-0">
                                {moment(item.departure_date).format("DD")}{" "}
                                <h6 className="font-weight-bold mb-1 ml-2">
                                  {" "}
                                  {moment(item.departure_date).format("MMM'YY")}
                                </h6>
                              </h3>
                              <span className="font-size-14 font-weight-semibold ">
                                {moment(item.departure_date).format("dddd")}
                              </span>
                            </div>
                          </Popover>
                        </div>
                      </div>
                      <div className="search-right remove-city-content">
                        {index <= 3 &&
                          index === multiCityControls.length - 1 && (
                            <button
                              className="add-more-city"
                              onClick={() => onAddMoreCity(index)}
                              onTouchStartCapture={() => onAddMoreCity(index)}
                            >
                              ADD MORE CITY
                            </button>
                          )}
                        {index > 0 &&
                          index === multiCityControls.length - 1 && (
                            <CloseCircleFilled
                              style={{ fontSize: "45px", opacity: 0.5 }}
                              onClick={() => onRemoveCity(index)}
                            />
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </>
          );
        })}
      </>
    );
  } else {
    return <div></div>;
  }
}
